<template>
  <layout-fullscreen bg="/images/photo-2.jpg">
    <div class="body">
      <h1 class="heading h2 t-inverse t-center">
        Create Account
      </h1>

      <div class="button-stack">
        <button class="button button--inverse button--inline-icon" @click="handleSocialAuth(facebookUrl)">
          <img class="icon" src="@/assets/icons/facebook.svg" alt="" role="presentation">
          Sign up with Facebook
        </button>

        <button class="button button--inverse button--inline-icon" @click="handleSocialAuth(googleUrl)">
          <img class="icon" src="@/assets/icons/google.svg" alt="" role="presentation">
          Sign up with Google
        </button>

        <router-link class="button button--inverse button--inline-icon" to="sign-up">
          <img class="icon" src="@/assets/icons/email.svg" alt="" role="presentation">
          Sign up with Email
        </router-link>
      </div> 

      <small class="t-inverse t-center">By creating an account you agree to our <a class="t-link" href="https://www.remax-malta.com/dataprotectionstatement.aspx" target="_blank">Terms & Conditions</a>.</small>
    </div>
  </layout-fullscreen>
</template>

<style scoped lang="scss">
  .button-stack {
    margin-bottom: 20px;
  }
</style>

<script>
  import socialAuth from '@/mixins/socialAuth';
  import LayoutFullscreen from '@/layouts/Fullscreen';
  import Navigation from '@/components/Navigation';

  export default {
    name: 'AccountCreate',

    mixins: [socialAuth],

    components: {
      LayoutFullscreen,
      Navigation
    }
  };
</script>